exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.floating-button-wrapper[data-v-265b6c11]{position:inherit\n}\n.floating-button[data-v-265b6c11]{width:35px;height:35px;display:flex;flex-direction:column;justify-content:center;align-items:center;border-radius:50%;transition:all 0.1s ease-in-out;opacity:0.75\n}\n.floating-button[data-v-265b6c11]:hover{transform:scale(1.1);border-radius:50%\n}\n", ""]);

// exports
